import { Component, inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AccountService } from 'src/app/services/account.service';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/models/user.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    imports: [FormsModule, ReactiveFormsModule, NgClass, RouterLinkActive, RouterLink]
})

export class LoginComponent {

  private formBuilder = inject(FormBuilder);
  private accountService = inject(AccountService);

  public profileForm: FormGroup;
  private username: FormControl;
  private password: FormControl;
  f: Record<string, AbstractControl>;

  user: User;

  LogInMessage: string;
  isWaitingReq = false;

  constructor() {
    this.username = new FormControl('', [Validators.required])
    this.password = new FormControl('', [Validators.required, Validators.minLength(6)])

    this.profileForm = this.formBuilder.group({
      username: this.username,
      password: this.password
    })
    this.f = this.profileForm.controls;
    this.subscribeUser();
  }

  subscribeUser() {
    this.accountService.userObservable
      .pipe(takeUntilDestroyed())
      .subscribe(
        (next: User) => {
          this.user = next;
        }
      )
  }

  isUserLoggedIn(): boolean {
    if (this.user === null)
      return false;
    else return this.user.isLogin;
  }

  onSubmit() {
    if (this.profileForm.invalid) {
      this.LogInMessage = "Invalid username or password"
      return;
    }
    if (this.isWaitingReq)
      return;
    this.LogInMessage = "Please Wait"
    this.isWaitingReq = true;
    this.login(this.profileForm.value.username, this.profileForm.value.password);
  }

  login(User : string, Pass : string) {
    this.accountService.login(User, Pass)
    .subscribe(
      () => {
        this.isWaitingReq = false;
      },
      (error) => {
        this.LogInMessage = this.accountService.getErrorStr(error.status);
        this.isWaitingReq = false;
      }
    );
  }

  passwordReset()
  {
    window.location.href = environment.apiURL + "/password-reset/";
  }

  loginWithSteam(){
    window.location.href = environment.apiURL + "/login/steam/";
  }

  logout() {
    this.accountService.logout()
    .subscribe(
      () => {
      }
    );
  }
}
